/**
 * The values saved on a connection before its OAuth sign-in link is asked for: the sign-in it uses
 * (`type`, `authId`), its label, each field's default, and what the person typed (trimmed). Same
 * shape the earlier frontend's connection window saved, so the API's sign-in link can read them.
 * `missing` lists the required fields still empty, which the person has to fill first.
 */
const buildProviderSignInSecrets = ({ auth, fields = [], values = {}, label }) => {
  const isFilled = (value) => typeof value === 'boolean' || typeof value === 'number' || String(value ?? '').trim() !== '';
  const secrets = { type: auth.type, authId: auth.id, label };
  const missing = [];

  for (const field of fields) {
    const typed = typeof values?.[field.key] === 'string' ? values[field.key].trim() : values?.[field.key];
    const value = isFilled(typed) ? typed : field.defaultValue;

    if (isFilled(value)) {
      secrets[field.key] = value;
    } else if (field.required === true) {
      missing.push(field.key);
    }
  }

  return { secrets, missing };
};

export default buildProviderSignInSecrets;
